<template>
  <v-container class="payment-container">
    <v-expansion-panel popout light class="futuristic-expansion">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>
            <h4 class="earth-color">GLOBAL SEARCH</h4>
            <div class="title-decoration"></div>
          </div>
        </template>
        <template v-slot:actions>
          <v-icon color="#587e27">$vuetify.icons.expand</v-icon>
        </template>
        <v-card flat class="futuristic-card">
          <v-card-text>
            <div>
              <h6 class="earth-color">KEYWORD SEARCH</h6>
              <div class="title-decoration"></div>
            </div>
            <v-form @submit.prevent="searchTerm()">
              <v-layout row wrap>
                <v-flex lg8 md8 sm8 xs10>
                  <v-container>
                    <v-text-field
                      label="Search by: Email, Name, Phone Number"
                      v-model="term.key"
                      required
                      class="futuristic-input"
                    ></v-text-field>
                  </v-container>
                </v-flex>
                <v-flex lg4 md4 sm4 xs12>
                  <v-container fluid>
                    <v-btn
                      :depressed="true"
                      color="#587e27"
                      type="submit"
                      class="futuristic-btn"
                    >
                      <v-icon>search</v-icon>
                    </v-btn>
                    <v-btn
                      :depressed="true"
                      color="#e84118"
                      @click="reset()"
                      class="futuristic-btn"
                    >Reset</v-btn>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-card flat class="futuristic-card">
      <v-card-title class="card-header">
        <v-dialog v-model="ban_booking_dialog" persistent max-width="600px">
          <v-btn
            :depressed="true"
            color="#587e27"
            class="white--text futuristic-btn"
            slot="activator"
          >BAN A Booking</v-btn>
          <v-card class="futuristic-card">
            <v-card-title>
              <div>
                <h4 class="earth-color">BURN DETAILS</h4>
                <div class="title-decoration"></div>
              </div>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      label="First Name"
                      v-model="ban_booking.first_name"
                      required
                      class="futuristic-input"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Last Name"
                      v-model="ban_booking.last_name"
                      required
                      class="futuristic-input"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <v-autocomplete
                      label="Country"
                      v-model="ban_booking.code"
                      :items="allCountries"
                      :rules="[v => !!v || 'Country is required']"
                      required
                      item-text="name"
                      item-value="code"
                      @change="findCountryCode"
                      :loading="$loadingTrue"
                      class="futuristic-input"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex lg8 md8 sm12 xs12>
                    <v-text-field
                      label="Phone Number (+***)"
                      v-model="ban_booking.phone_number"
                      type="tel"
                      hint="Start with country code."
                      class="futuristic-input"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Email"
                      v-model="ban_booking.email_address"
                      required
                      type="email"
                      class="futuristic-input"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg8 md8 sm12 xs12>
                    <v-text-field
                      label="Ban Period"
                      type="number"
                      v-model="ban_booking.ban_period"
                      suffix="Days"
                      required
                      class="futuristic-input"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Vehicle Registration"
                      v-model="ban_booking.vehicle_registration"
                      required
                      class="futuristic-input"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="#e84118"
                flat
                @click="ban_booking_dialog = false"
                class="futuristic-btn"
              >Close</v-btn>
              <v-btn
                color="#587e27"
                flat
                @click="postBan()"
                class="futuristic-btn"
              >Ban Booking</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
          class="futuristic-search"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="columns"
        :items="getBookingsBan"
        :search="search"
        :pagination.sync="pagination"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
        class="futuristic-table"
      >
        <v-progress-linear slot="progress" color="#587e27" indeterminate></v-progress-linear>
        <template v-slot:items="props">
          <td data-label="Name">{{ props.item.first_name }} {{ props.item.last_name }}</td>
          <td data-label="Email">{{ props.item.email_address }}</td>
          <td data-label="Phone Number">{{ props.item.phone_number }}</td>
          <td data-label="Ban Period">
            {{ formated_date(props.item.booking_ban_start_date) }} <b>TO</b>
            {{ formated_date(props.item.booking_ban_end_date) }}
          </td>
          <td data-label="Ban Status" :style="props.item.booking_color">{{ props.item.status }}</td>
          <td data-label="Ban By">
            {{ props.item.session_user }} <b>ON</b>
            {{ formated_date(props.item.created_at) }}
          </td>
          <td data-label="Action">
            <v-btn
              :depressed="true"
              color="#587e27"
              @click="updateBookingsBan(props.item.booking_ban_public_id)"
              class="futuristic-btn"
            >View/Update</v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 sm6 md4 lg3>
            <v-select
              :items="rowsPerPageItems"
              v-model="pagination.rowsPerPage"
              label="Rows per page"
              class="futuristic-input"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6>
            <v-btn
              :depressed="true"
              color="#587e27"
              @click="getMore()"
              :loading="this.$store.state.LoadingStore.loading"
              class="futuristic-btn"
            >GET MORE</v-btn>
            <v-btn
              :depressed="true"
              color="#587e27"
              @click="getAllBookingsBan()"
              :loading="this.$store.state.LoadingStore.loading"
              class="futuristic-btn"
            >GET ALL</v-btn>
            <vue-json-to-csv
              :json-data="getBookingsBanCSV"
              csv-title="Booking Bans"
              :labels="{
                first_name: { title: 'First Name' },
                last_name: { title: 'Last Name' },
                email_address: { title: 'Email' },
                phone_number: { title: 'Phone Number' },
                vehicle_registration: { title: 'Vehicle Registration' },
                booking_ban_start_date: { title: 'Ban Start Date' },
                booking_ban_end_date: { title: 'Ban End Date' },
                status: { title: 'Ban Status' },
                session_user: { title: 'Ban By' },
                created_at: { title: 'Ban On Date' },
              }"
            >
              <v-btn
                :depressed="true"
                color="#f1c40f"
                :loading="$loadingTrue"
                class="futuristic-btn"
              >Download Alerts(CSV)</v-btn>
            </vue-json-to-csv>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import SearchTabs from "./FindBooking";
import VueJsonToCsv from "vue-json-to-csv";
export default {
  components: { SearchTabs, VueJsonToCsv },
  name: "BookingsBan",
  data() {
    return {
      search: "",
      term: {
        key: "",
      },
      page: 2,
      columns: [
        {
          text: "Name",
          value: "first_name",
        },
        {
          text: "Email",
          value: "email_address",
        },
        {
          text: "Phone Number",
          value: "phone_number",
        },
        {
          text: "Ban Period",
          value: "booking_ban_start_date",
        },
        {
          text: "Ban Status",
          value: "status",
        },
        {
          text: "Ban By",
          value: "session_user",
        },
        {
          text: "Action",
          value: "",
        },
      ],
      ban_booking_dialog: false,
      ban_booking: {
        first_name: "",
        last_name: "",
        email_address: "",
        phone_number: "",
        code: "254",
        vehicle_registration: "",
        ban_period: 0,
        session_id: localStorage.getItem("lkjhgfdsa"),
      },
      pagination: {
        rowsPerPage: 10
      },
      rowsPerPageItems: [10, 25, { text: 'All', value: -1 }],
    };
  },
  created() {
    this.$store.dispatch("get_all_bookings_ban");
    this.$store.dispatch("get_all_countries");
  },
  methods: {
    updateBookingsBan: function (booking_ban_id) {
      this.$router.push({
        name: "ViewBookingBan",
        params: {
          booking_ban_id: booking_ban_id,
        },
      });
    },
    searchTerm: function () {
      this.$store.dispatch("search_booking_ban", this.term);
    },
    postBan: function () {
      this.ban_booking_dialog = false;
      this.$store.dispatch("post_booking_ban", this.ban_booking);
    },
    getUnticketed: function (publicId) {
      this.$router.push({
        name: "BookingUnticketedAlert",
      });
    },
    findCountryCode(data) {
      var instance = this;
      this.allCountries.map(function (country) {
        if (data === country.code) {
          instance.ban_booking.phone_number = "+" + country.calling_code;
          instance.ban_booking.code = data;
        }
      });
    },
    reset() {
      this.term.key = "";
      this.$store.dispatch("get_all_bookings_ban");
    },
    getMore() {
      this.loading = true;
      if (this.page === 2) {
        this.$store.dispatch("get_more_bookings_ban", this.page);
        this.page = this.page + 1;
      } else {
        this.$store.dispatch("get_more_bookings_ban", this.page);
        this.page = this.page + 1;
      }
    },
    getAllBookingsBan() {
      this.loading = true;
      this.page = 0;
      this.$store.dispatch("get_all_bookings_ban", this.page);
    },
  },
  computed: {
    getBookingsBan() {
      return this.$store.state.BookingStore.all_bookings_ban || [];
    },
    getBookingsBanCSV() {
      let all_bans = this.$store.state.BookingStore.all_bookings_ban || [];
      let bans_arr = [];
      for (let i = 0; i < all_bans.length; i++) {
        let ban_obj = {};
        ban_obj["first_name"] = all_bans[i].first_name;
        ban_obj["last_name"] = all_bans[i].last_name;
        ban_obj["email_address"] = all_bans[i].email_address;
        ban_obj["phone_number"] = all_bans[i].phone_number;
        ban_obj["vehicle_registration"] = all_bans[i].vehicle_registration;
        ban_obj["booking_ban_start_date"] = this.formated_date(all_bans[i].booking_ban_start_date);
        ban_obj["booking_ban_end_date"] = this.formated_date(all_bans[i].booking_ban_end_date);
        ban_obj["status"] = all_bans[i].status;
        ban_obj["session_user"] = all_bans[i].session_user;
        ban_obj["created_at"] = this.formated_date(all_bans[i].created_at);
        bans_arr.push(ban_obj);
      }
      return bans_arr;
    },
  },
};
</script>

<style scoped>
/* Futuristic Container */
.payment-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.payment-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-expansion {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-expansion:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.futuristic-table {
  border-radius: 8px;
  background: #ffffff;
}

.futuristic-table >>> th {
  color: #587e27;
  font-weight: 600;
}

.futuristic-link {
  color: #587e27;
  text-decoration: none;
  transition: color 0.2s ease;
}

.futuristic-link:hover {
  color: #1b5e20;
}

.futuristic-alert {
  border-radius: 8px;
  background: #fff5f5;
}

.futuristic-search >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .payment-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.25rem;
  }

  .futuristic-btn {
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .payment-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.1rem;
  }

  .futuristic-btn {
    font-size: 0.85rem;
  }
}
</style>